import { apiClient } from "../../../lib";

class ImportService {

    async getBatchDetail({ page, limit, batchHeaderId }: { page: number, limit: number, batchHeaderId?: string }): Promise<any> {
        const response = await apiClient.get<any>('/import-data/batch-detail', { params: { page, limit, batch_header_id: batchHeaderId } });
        return response.data.data;
    };

    async getBatchList(params?: {
        page?: number;
        limit?: number;
        status?: string;
        searchKey?: string;
    }): Promise<any> {
        const response = await apiClient.get<any>('/import-data/batch-header', { params: { page: params?.page, limit: params?.limit, search_term: params?.searchKey } });
        return response.data.data;
    };

    async getTemplates(): Promise<any> {
        const response = await apiClient.get<any>('/import-data/template');
        return response.data.data;
    };

    async getPreSign(): Promise<any> {
        const response = await apiClient.get<any>('/import-data/pre-signed-url');
        return response.data.data;
    };

    async upload({ type, s3_filekey }: { type: string, s3_filekey: string }): Promise<any> {
        return apiClient.post<any>(`/import-data`, { s3_filekey, file_type: type } 
    );
    };

}

export const importService = new ImportService();
export default importService;